import { useQuery } from '@tanstack/react-query'
import { getAllTokensForOwner } from 'src/common/api-clients/alchemy'
import useActiveOrDefaultChain from '../../hooks/web3/useActiveOrDefaultChain'

export const useAllTokensForOwner = (
  address?: string,
  contractAddresses?: string[]
) => {
  const chain = useActiveOrDefaultChain()

  const { data, ...rest } = useQuery({
    queryFn: () => getAllTokensForOwner(address, contractAddresses, chain?.id),
    queryKey: [
      'allTokensForOwner',
      address,
      contractAddresses?.join(','),
      chain.id,
    ],
    staleTime: 30000,
  })

  return {
    ownedErc20s: data || [],
    ...rest,
  }
}
